var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-content" },
    [
      _c(
        "div",
        { staticClass: "content_wrap" },
        [
          _vm.activeRouteProp === null
            ? [
                _c(
                  "SuggestQuestion",
                  _vm._g(
                    _vm._b(
                      {
                        attrs: {
                          source: _vm.source,
                          sourceType: _vm.sourceType,
                        },
                      },
                      "SuggestQuestion",
                      _vm.$attrs,
                      false
                    ),
                    _vm.$listeners
                  )
                ),
              ]
            : [
                _c(
                  "Dialogue",
                  _vm._g(
                    _vm._b({}, "Dialogue", _vm.$attrs, false),
                    _vm.$listeners
                  )
                ),
              ],
        ],
        2
      ),
      !_vm.source
        ? _c(
            "div",
            { staticClass: "zzpBtns" },
            [
              _vm._l(_vm.$store.state.aiChat.zzpSelectBtn, function (item, i) {
                return [
                  item.type === 6 || item.type === 7
                    ? _c(
                        "el-tooltip",
                        {
                          key: i,
                          attrs: {
                            content: item.content,
                            placement: "top",
                            overflow: "",
                            "open-delay": 300,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              key: i,
                              attrs: { type: "plain", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.zzpBtnsClick(item)
                                },
                              },
                            },
                            [
                              _vm._v(" " + _vm._s(_vm.getBtnName(item)) + " "),
                              _c("i", {
                                staticClass: "el-icon-error",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.delBtn(i)
                                  },
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      )
                    : item.type === 3
                    ? _c(
                        "el-tooltip",
                        {
                          key: i,
                          attrs: {
                            placement: "top",
                            overflow: "",
                            "open-delay": 300,
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.dynamicHtml(item)),
                                },
                              }),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              key: i,
                              attrs: { type: "plain", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.zzpBtnsClick(item)
                                },
                              },
                            },
                            [
                              _vm._v(" " + _vm._s(_vm.getBtnName(item)) + " "),
                              _c("i", {
                                staticClass: "el-icon-error",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.delBtn(i)
                                  },
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      )
                    : item.type === 4 || item.type === 5
                    ? _c(
                        "el-tooltip",
                        {
                          key: i,
                          attrs: {
                            placement: "top",
                            overflow: "",
                            "open-delay": 300,
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c("div", [
                                _vm._v(_vm._s(_vm.getRecordingTooltip(item))),
                              ]),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              key: i,
                              attrs: { type: "plain", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.zzpBtnsClick(item)
                                },
                              },
                            },
                            [
                              _vm._v(" " + _vm._s(_vm.getBtnName(item)) + " "),
                              _c("i", {
                                staticClass: "el-icon-error",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.delBtn(i)
                                  },
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      )
                    : item.type === 8
                    ? _c(
                        "el-tooltip",
                        {
                          key: i,
                          attrs: {
                            content: item.content,
                            placement: "top",
                            overflow: "",
                            "open-delay": 300,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              key: i,
                              attrs: { type: "plain", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.zzpBtnsClick(item)
                                },
                              },
                            },
                            [
                              _vm._v(" " + _vm._s(_vm.getBtnName(item)) + " "),
                              _c("i", {
                                staticClass: "el-icon-error",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.delBtn(i)
                                  },
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      )
                    : item.type === 9
                    ? _c(
                        "el-tooltip",
                        {
                          key: i,
                          attrs: {
                            placement: "top",
                            overflow: "",
                            "open-delay": 300,
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c("div", [
                                _vm._v(_vm._s(_vm.getProfileTooltip(item))),
                              ]),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              key: i,
                              attrs: { type: "plain", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.zzpBtnsClick(item)
                                },
                              },
                            },
                            [
                              _vm._v(" " + _vm._s(_vm.getBtnName(item)) + " "),
                              _c("i", {
                                staticClass: "el-icon-error",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.delBtn(i)
                                  },
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "el-button",
                        {
                          key: i,
                          attrs: { type: "plain", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.zzpBtnsClick(item)
                            },
                          },
                        },
                        [
                          _vm._v(" " + _vm._s(_vm.getBtnName(item)) + " "),
                          _c("i", {
                            staticClass: "el-icon-error",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.delBtn(i)
                              },
                            },
                          }),
                        ]
                      ),
                ]
              }),
              _c(
                "el-dropdown",
                {
                  attrs: { trigger: "click" },
                  on: { command: _vm.handleCommand },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-plus-bold",
                      },
                    },
                    [_vm._v("素材")]
                  ),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    _vm._l(_vm.zzpBtnList, function (item, i) {
                      return _c(
                        "el-dropdown-item",
                        {
                          key: i,
                          attrs: {
                            command: item.value,
                            disabled: _vm.btnIsDisabled(item),
                          },
                        },
                        [_vm._v(_vm._s(item.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
      (_vm.source === "global" || _vm.source === "wenshu") &&
      _vm.showSourceSelect
        ? _c(
            "div",
            { staticClass: "source-select-wrap" },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    size: "small",
                    placeholder: "请选择",
                    disabled: _vm.$store.state.aiChat.textareaIsDisabled,
                  },
                  model: {
                    value: _vm.sourceType,
                    callback: function ($$v) {
                      _vm.sourceType = $$v
                    },
                    expression: "sourceType",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "AI员工", value: "global" },
                  }),
                  _c("el-option", {
                    attrs: { label: "AI问数", value: "wenshu" },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "textarea_wrap" },
        [
          _c(
            "CustomTextArea",
            _vm._g(
              _vm._b(
                { attrs: { source: _vm.source, sourceType: _vm.sourceType } },
                "CustomTextArea",
                _vm.$attrs,
                false
              ),
              _vm.$listeners
            )
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          ref: "dialog",
          staticClass: "recording_dialog",
          attrs: {
            title: "录音选择",
            "append-to-body": true,
            visible: _vm.visible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            close: _vm.dialogClose,
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "recording-box file-list",
            },
            [
              _vm._l(_vm.fileList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "file-item",
                    class: [
                      _vm.selectRecordingIds.includes(item.id)
                        ? "selectRecording"
                        : "",
                      _vm.recordingIsSelect(item) ? "recordingNoSelect" : "",
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.selectRecordingFn(item)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "fileItemHeader" }, [
                      _c("div", { staticClass: "file-item-l" }, [
                        _c(
                          "div",
                          { staticClass: "file-item-l01" },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "icon svg-icon file-type",
                                attrs: { "aria-hidden": "true" },
                              },
                              [
                                _c("use", {
                                  attrs: { "xlink:href": "#icon-MP3" },
                                }),
                              ]
                            ),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: item.name,
                                  placement: "top",
                                  overflow: "",
                                },
                              },
                              [
                                _c("span", { staticClass: "file-item-name" }, [
                                  _vm._v(_vm._s(item.name)),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm.$store.state.app.equityIds.includes("536")
                        ? _c(
                            "div",
                            { staticClass: "file-item-r" },
                            [
                              (item.multipartUploadRecordDTO === null &&
                                item.taskStatus === 0) ||
                              item.taskStatus === 3 ||
                              (item.multipartUploadRecordDTO &&
                                item.multipartUploadRecordDTO.transCode ===
                                  "Success" &&
                                item.taskStatus === 0)
                                ? _c(
                                    "el-button",
                                    {
                                      staticStyle: { color: "#165dff" },
                                      attrs: { type: "text", size: "mini" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.convertAudioToText(item)
                                        },
                                      },
                                    },
                                    [_vm._v(" 异步录音转文字 ")]
                                  )
                                : _vm._e(),
                              item.taskStatus === 1 ||
                              (item.multipartUploadRecordDTO &&
                                item.multipartUploadRecordDTO.transCode !=
                                  "Success" &&
                                item.multipartUploadRecordDTO.state !== 0)
                                ? _c(
                                    "div",
                                    { staticClass: "file-item-r recording" },
                                    [_vm._v(" 转化文字中 ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]
                )
              }),
              _vm.fileList.length === 0
                ? _c("div", { staticClass: "content-empty" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/images/followempty.png"),
                        alt: "",
                      },
                    }),
                    _c("p", [_vm._v("暂无数据")]),
                  ])
                : _vm._e(),
            ],
            2
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "secondary", size: "small" },
                  on: { click: _vm.dialogClose },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.saveConfirm },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "related-evaluation",
          attrs: {
            title: "关联测评",
            visible: _vm.evaluationDialogVisible,
            width: "1000px",
            "title-height": 48,
            "append-to-body": true,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.evaluationDialogVisible = $event
            },
            close: _vm.evaluationDialogClose,
          },
        },
        [
          _c(
            "public-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.evaluationTableLoading,
                  expression: "evaluationTableLoading",
                },
              ],
              ref: "evaluationTable",
              staticClass: "publictable",
              attrs: {
                tableData: _vm.evaluationTableData,
                tableColumns: _vm.evaluationTableColumns,
                tableConfig: _vm.evaluationTableConfig,
                paginationConfig: _vm.evaluationPaginationConfig,
              },
              on: { handleSelectChange: _vm.handleEvaluationSelectChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  slot: "assessmentTools",
                  prop: "assessmentTools",
                  label: "测评工具",
                  width: "260",
                },
                slot: "assessmentTools",
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "div",
                          { staticClass: "tag-wrapper" },
                          [
                            _c(
                              "el-tag",
                              {
                                staticClass: "tag-more",
                                attrs: { "bg-type": "grey" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    row.currentReportInfo &&
                                      row.currentReportInfo.scaleName
                                  )
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "div",
                { staticClass: "btn-right" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "secondary" },
                      on: { click: _vm.evaluationDialogClose },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        loading: _vm.evaluationLoading,
                      },
                      on: { click: _vm.evaluationConfirm },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "职位画像管理",
            visible: _vm.positionProfileDrawerVisible,
            direction: "rtl",
            size: "600px",
            "append-to-body": true,
            "modal-append-to-body": false,
            wrapperClosable: true,
            "custom-class": "position-profile-drawer-wrapper",
          },
          on: {
            "update:visible": function ($event) {
              _vm.positionProfileDrawerVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "position-profile-drawer" }, [
            _c("div", { staticClass: "toolbar" }, [
              _c(
                "div",
                { staticClass: "toolbar-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-plus",
                      },
                      on: { click: _vm.showAddForm },
                    },
                    [_vm._v("新增职位画像")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        size: "small",
                        icon: "el-icon-delete",
                        disabled: _vm.selectedProfileIds.size === 0,
                      },
                      on: { click: _vm.deleteSelected },
                    },
                    [_vm._v("删除选中")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "default", size: "small" },
                      on: { click: _vm.toggleSelectAll },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.selectedProfileIds.size === _vm.profileList.length
                            ? "取消全选"
                            : "全选"
                        )
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm.selectedProfileIds.size > 0
                ? _c("div", { staticClass: "selection-info" }, [
                    _c("i", { staticClass: "el-icon-check" }),
                    _vm._v(" 已选择 "),
                    _c("strong", [_vm._v(_vm._s(_vm.selectedProfileIds.size))]),
                    _vm._v(" 个职位画像 "),
                  ])
                : _vm._e(),
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.profileListLoading,
                    expression: "profileListLoading",
                  },
                ],
                staticClass: "content-area",
              },
              [
                _vm.profileList.length > 0 && !_vm.profileListLoading
                  ? _c(
                      "div",
                      { staticClass: "profile-list" },
                      _vm._l(_vm.profileList, function (profile) {
                        return _c(
                          "div",
                          {
                            key: profile.id,
                            staticClass: "profile-item",
                            class: {
                              selected: _vm.selectedProfileIds.has(profile.id),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleCardClick($event, profile.id)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "profile-item-header" },
                              [
                                _c("el-checkbox", {
                                  attrs: {
                                    value: _vm.selectedProfileIds.has(
                                      profile.id
                                    ),
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.toggleSelection(profile.id)
                                    },
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                }),
                                _c("span", { staticClass: "profile-name" }, [
                                  _vm._v(_vm._s(profile.profileName)),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass: "profile-actions",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                      },
                                    },
                                  },
                                  [
                                    _c("el-button", {
                                      class: {
                                        "default-active": profile.isDefault,
                                      },
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-star-off",
                                        title: profile.isDefault
                                          ? "取消默认"
                                          : "设为默认",
                                        size: "large",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleDefault(profile)
                                        },
                                      },
                                    }),
                                    _c("el-button", {
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-edit",
                                        title: "编辑",
                                        size: "large",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.editProfile(profile.id)
                                        },
                                      },
                                    }),
                                    _c("el-button", {
                                      staticClass: "delete-btn",
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-delete",
                                        title: "删除",
                                        size: "large",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteProfile(profile.id)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "profile-content" }, [
                              _vm._v(_vm._s(profile.profileContent)),
                            ]),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm.profileList.length === 0 && !_vm.profileListLoading
                  ? _c("div", { staticClass: "empty-state" }, [
                      _c("i", {
                        staticClass: "el-icon-document",
                        staticStyle: { "font-size": "64px", color: "#dcdfe6" },
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-top": "16px",
                            color: "#909399",
                          },
                        },
                        [_vm._v('暂无职位画像，点击"新增职位画像"创建')]
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
          ]),
          _c(
            "div",
            { staticClass: "drawer-footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "plain" },
                  on: {
                    click: function ($event) {
                      _vm.positionProfileDrawerVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmSelection },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.profileFormLoading,
              expression: "profileFormLoading",
            },
          ],
          attrs: {
            title: _vm.editingProfileId ? "编辑职位画像" : "新增职位画像",
            visible: _vm.profileDialogVisible,
            width: "600px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.profileDialogVisible = $event
            },
            close: _vm.cancelEdit,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "profileFormRef",
              staticClass: "profileDialogForm",
              attrs: {
                model: _vm.profileForm,
                rules: _vm.profileFormRules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "画像名称", prop: "profileName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入画像名称" },
                    model: {
                      value: _vm.profileForm.profileName,
                      callback: function ($$v) {
                        _vm.$set(_vm.profileForm, "profileName", $$v)
                      },
                      expression: "profileForm.profileName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "画像内容", prop: "profileContent" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入画像内容描述",
                      rows: 6,
                      maxLength: 300,
                      "show-word-limit": true,
                    },
                    model: {
                      value: _vm.profileForm.profileContent,
                      callback: function ($$v) {
                        _vm.$set(_vm.profileForm, "profileContent", $$v)
                      },
                      expression: "profileForm.profileContent",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.profileFormLoading },
                  on: { click: _vm.cancelEdit },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.profileFormLoading },
                  on: { click: _vm.saveProfile },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }